import { object, string, array, number, SchemaOf } from 'yup';

import { DockerRegistryFormValues } from './types';

export const dockerRegistryValidationSchema: SchemaOf<DockerRegistryFormValues> =
  object({
    name: string()
      .required('Policy name is required')
      .trim()
      .min(1, 'Policy name is required'),
    environmentGroupIds: array(number().required()),
    accessRows: array(
      object({
        registryId: number().required(),
        userIds: array(number().required()),
        teamIds: array(number().required()),
      })
    ).min(1, 'At least one registry access configuration is required'),
  });
